import BaseService from "@/api/services/BaseService";
import type ServiceInterface from "@/api/services/ServiceInterface";
import type {
  ResourceItem,
  SupportedResource,
  UploadResult,
} from "@/types/resources";

const maxUploadTimeout = import.meta.env.VITE_API_MAX_RESOURCE_UPLOAD_TIMEOUT || 30000;

export default class ServiceResources
  extends BaseService
  implements ServiceInterface
{
  async getSupportedResources(): Promise<SupportedResource[]> {
    const response = await this.rest.request({
      url: "/api/resources",
      method: "get",
    });
    return response.data || [];
  }

  async loadItems(type: string, page: number = 1, limit: number = 100, searchText: string = ''): Promise<{data: ResourceItem[], headers: object}> {
    const params: Record<string, any> = {};
    if (searchText && searchText.length > 0) {
      params.q = searchText;
    };

    const baseGet = this.rest.baseGet(
      {
        url: `/api/resources/${type}`,
        method: "get",
        params: params,
      },
      limit,
      page
    );
    return baseGet
  }

  async upload(type: string, files: File[]): Promise<UploadResult> {
    return new Promise((resolve, reject) => {
      const data = new FormData();
      for (const file of files) {
        data.append("file", file);
      }
      this.rest
        .request({
          method: "post",
          url: `/api/resources/${type}`,
          data,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }, maxUploadTimeout)
        .then((response) => {
          resolve({
            success: true,
            response: response.data as ResourceItem,
          });
        })
        .catch((e) => {
          reject(e);
        });
    });
  }

  async deleteResource(file: ResourceItem): Promise<boolean> {
    const response = await this.rest.request({
      method: "delete",
      url: `/api/resources/${file.type}/${file.id}`,
    });
    return response.data?.code === "OK";
  }
}
